/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Datagrid_Selectall2Inputs */

const en_datagrid_selectall2 = /** @type {(inputs: Datagrid_Selectall2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select all`)
};

/**
* | output |
* | --- |
* | "Select all" |
*
* @param {Datagrid_Selectall2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const datagrid_selectall2 = /** @type {((inputs?: Datagrid_Selectall2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Datagrid_Selectall2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_datagrid_selectall2(inputs)
});
export { datagrid_selectall2 as "dataGrid_selectAll" }